import LessonFork from "../../../../src/components/lesson-fork.js";
import * as React from 'react';
export default {
  LessonFork,
  React
};